import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { Card } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { API } from '../App';
import { Check, X, Sparkles } from 'lucide-react';

const WA_NUMBER = '971521310804';
const waLink = (msg) => `https://wa.me/${WA_NUMBER}?text=${encodeURIComponent(msg)}`;

export default function PricingPage() {
  const [plans, setPlans] = useState([]);

  useEffect(() => {
    axios.get(`${API}/plans`).then(r => setPlans(r.data.plans || [])).catch(() => {});
  }, []);

  return (
    <div className="min-h-screen flex flex-col bg-gray-50">
      <Header />
      <main className="flex-1 container mx-auto px-4 py-16 max-w-7xl">
        <div className="text-center mb-12">
          <h1 className="text-4xl font-bold mb-3">Choose the Right Career Support Package</h1>
          <p className="text-gray-600">One-time UAE pricing. No hidden fees.</p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-5">
          {plans.map(p => (
            <Card key={p.key} data-testid={`plan-${p.key}`}
              className={`p-5 flex flex-col ${p.recommended ? 'border-2 border-[#CE1126] shadow-xl relative' : 'border'}`}>
              {p.recommended && (
                <span className="absolute -top-3 left-1/2 -translate-x-1/2 bg-[#CE1126] text-white text-xs px-3 py-1 rounded-full font-semibold">
                  <Sparkles className="w-3 h-3 inline mr-1" />Recommended
                </span>
              )}
              <h3 className="text-xl font-bold mb-1">{p.label}</h3>
              <p className="text-3xl font-bold mb-1">
                {p.price_aed === 0 ? 'Free' : <>AED {p.price_aed}</>}
              </p>
              <p className="text-xs text-gray-500 mb-3">{p.positioning}</p>
              <p className="text-xs text-gray-600 mb-3 italic">{p.best_for}</p>

              <ul className="space-y-1.5 text-sm mb-4 flex-1">
                {p.features.map(f => (
                  <li key={f} className="flex items-start gap-2">
                    <Check className="w-4 h-4 text-[#009639] mt-0.5 shrink-0" /><span>{f}</span>
                  </li>
                ))}
                {p.not_included?.map(f => (
                  <li key={f} className="flex items-start gap-2 text-gray-400">
                    <X className="w-4 h-4 mt-0.5 shrink-0" /><span className="line-through">{f}</span>
                  </li>
                ))}
              </ul>

              {p.disclaimer && (
                <p className="text-xs text-amber-700 mb-3 italic">{p.disclaimer}</p>
              )}

              {p.key === 'free' ? (
                <Link to="/cv"><Button className="w-full btn-uae-green" data-testid={`cta-${p.key}`}>{p.cta}</Button></Link>
              ) : (
                <a href={waLink(`Hi, I'd like to purchase the ${p.label} plan (AED ${p.price_aed}).`)}
                   target="_blank" rel="noopener noreferrer">
                  <Button className={`w-full ${p.recommended ? 'btn-uae-red' : 'btn-uae-green'}`} data-testid={`cta-${p.key}`}>
                    {p.cta}
                  </Button>
                </a>
              )}
            </Card>
          ))}
        </div>

        <div className="mt-8 text-center text-xs text-gray-500">
          Payment via WhatsApp (verified manual). Support: Admin@dailyuaejobs.com · +971 52 131 0804
        </div>
      </main>
      <Footer />
    </div>
  );
}
